import { initialMenus } from '@/data/sitemap';

const WORKSPACES_KEY = 'sitemap_workspaces_v1';
const LEGACY_KEY = 'sitemap_project_data_v1';

// Helper: Generate ID
const generateId = () => `ws-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

// Default Theme Definition
const DEFAULT_THEME = {
  primary: '#6366f1',    // Indigo-500
  secondary: '#f8fafc',  // Slate-50
  nodeBg: '#ffffff',     // White
  lineColor: '#cbd5e1',  // Slate-300
  textColor: '#1e293b'   // Slate-800
};

// ----------------------------------------------------------------------
// 📦 Migration & Initialization
// ----------------------------------------------------------------------
export const initWorkspaces = () => {
  try {
    const existing = localStorage.getItem(WORKSPACES_KEY);
    if (existing) return JSON.parse(existing);

    // Migration: Check for legacy single-project data
    const legacy = localStorage.getItem(LEGACY_KEY);
    if (legacy) {
      const legacyData = JSON.parse(legacy);
      const initialWorkspace = {
        id: generateId(),
        ...legacyData,
        theme: legacyData.theme || DEFAULT_THEME, // Add default theme if missing
        lastModified: Date.now()
      };
      const workspaces = [initialWorkspace];
      localStorage.setItem(WORKSPACES_KEY, JSON.stringify(workspaces));
      return workspaces;
    }

    // Default: Empty list (No sample workspaces)
    const empty = [];
    localStorage.setItem(WORKSPACES_KEY, JSON.stringify(empty));
    return empty;
  } catch (e) {
    console.error("Init failed", e);
    return [];
  }
};

// ----------------------------------------------------------------------
// 🛠️ CRUD Operations
// ----------------------------------------------------------------------
export const getAllWorkspaces = () => {
  try {
    const data = localStorage.getItem(WORKSPACES_KEY);
    return data ? JSON.parse(data) : initWorkspaces();
  } catch (e) {
    return [];
  }
};

export const createWorkspace = () => {
  const workspaces = getAllWorkspaces();
  const newWorkspace = {
    id: generateId(),
    title: "New Project",
    menus: initialMenus,
    // Start with default template
    activeId: initialMenus[0].id,
    theme: DEFAULT_THEME, // Apply default theme
    lastModified: Date.now()
  };
  
  workspaces.unshift(newWorkspace); // Add to top
  localStorage.setItem(WORKSPACES_KEY, JSON.stringify(workspaces));
  return newWorkspace;
};

export const saveWorkspace = (id, data) => {
  const workspaces = getAllWorkspaces();
  const index = workspaces.findIndex(w => w.id === id);
  if (index !== -1) {
    workspaces[index] = { ...workspaces[index], ...data, lastModified: Date.now() };
    localStorage.setItem(WORKSPACES_KEY, JSON.stringify(workspaces));
    return true;
  }
  return false;
};

export const deleteWorkspace = (id) => {
  const workspaces = getAllWorkspaces();
  const filtered = workspaces.filter(w => w.id !== id);
  localStorage.setItem(WORKSPACES_KEY, JSON.stringify(filtered));
  return filtered;
};